/**
 * MapCookie
 * 
 * Responsible for finding and parsing Marketing Automation Platform cookies.
 */
import CookieStore from "./storecookie";

export enum PardotTypeEnum {
    VisitorIdKey = 'VisitorIdKey',
    VisitorIdValue = 'VisitorIdValue',
    VisitorHashKey = 'VisitorHashKey',
    VisitorHashValue = 'VisitorHashValue',
}

export class MapCookie 
{


    public static getActiveDemand(store: CookieStore) : Array<string>
    {
        return store.get('activedemand_session_guid');
    }

    public static getActOn(store: CookieStore, valuesOnly: boolean) : Array<string> 
    {
        const allCookies = store.getAll();
        // sort cookie keys (alpha)
        // so we can be certain key at index N corresponds
        // to value at index N
        const keys = Object.keys(allCookies).sort();
        // check for any act-on cookies
        let cookies = [];
        for (let i = 0; i < keys.length; i ++) {
            const key = keys[i];
            if (key.match(/wp\d/)) {
                const values = store.get(key);
                if (values.length > 0) {
                    if (valuesOnly) {
                        for (let j = 0; j < values.length; j++) {
                            cookies.push(values[j]);
                        }
                    } else {
                        cookies.push(key);
                    }
                }
            }
        }
        return cookies;
    }

    public static getHubSpot(store: CookieStore) : Array<string>
    {
        return store.get('hubspotutk');
    }

    public static getPardotVisitor(store: CookieStore, type: PardotTypeEnum) : Array<string> 
    {
        let cookies = [];
        const allCookies = store.getAll();
        const keys = Object.keys(allCookies);
        for (let j = 0; j < keys.length; j ++) {
            const key = keys[j];
            if (key.match(/visitor_id[0-9]+/) && key.indexOf('hash') === -1) {
                const hashKey = `${key}-hash`;
                if (type === PardotTypeEnum.VisitorIdKey) {
                    cookies.push(key);
                }
                else if (type === PardotTypeEnum.VisitorIdValue) {
                    const visitorIds = store.get(key);
                    for (let k = 0; k < visitorIds.length; k ++) {
                        cookies.push(visitorIds[k]);
                    }
                }
                else if (type === PardotTypeEnum.VisitorHashKey) {
                    cookies.push(hashKey);
                }
                else if (type === PardotTypeEnum.VisitorHashValue) {
                    const hashValues = store.get(hashKey);
                    for (let v = 0; v < hashValues.length; v ++) {
                        cookies.push(hashValues[v]);
                    }
                }
            }
        }
        return cookies;
    }

    /**
     * Find marketing automation cookies for the supported platforms.
     * 
     * ActiveDemand, Act-On, Pardot.
     * 
     * @returns Record<string, Array<string>>
     */
    public static findAll() : Record<string, Array<string>>
    {
        const store = new CookieStore();

        const actonKeys   = MapCookie.getActOn(store, false);
        const actonValues = MapCookie.getActOn(store, true);
        const aoWp = actonKeys.map((key, i) => `${key}=${actonValues[i]}`);

        // Pardot pairs each visitor ID with its hash in one pass — the
        // getPardotVisitor modes don't guarantee index alignment when a hash
        // cookie is absent, so we can't safely zip them after the fact.
        const pdV: Array<string> = [];
        const pardotKeys = MapCookie.getPardotVisitor(store, PardotTypeEnum.VisitorIdKey);
        for (let j = 0; j < pardotKeys.length; j++) {
            const key = pardotKeys[j];
            const visitorId   = store.get(key);
            const hashKey     = `${key}-hash`;
            const visitorHash = store.get(hashKey);
            if (visitorId.length > 0 && visitorHash.length > 0) {
                pdV.push(`${key}=${visitorId[0]},${hashKey}=${visitorHash[0]}`);
            }
        }

        return {
            'ad_sg': MapCookie.getActiveDemand(store),
            'ao_wp': aoWp,
            'pd_v':  pdV,
            'hs_u':  MapCookie.getHubSpot(store),
        };
    }

}